import React from "react";
import { CancelOutlined, Add } from "@mui/icons-material";
import { CategoryItem, MenuItem } from "../../../interfaces/Catalogue";
import "./RewardClaimButton.scss";

interface RewardClaimButtonProps {
  articleClaimed: boolean;
  isClaimDisabled: boolean;
  selectedMenuItem: MenuItem | CategoryItem;
  updateArticleLoyality?: (isRemiseActive: boolean) => void;
}

const RewardClaimButton: React.FC<RewardClaimButtonProps> = ({
  articleClaimed,
  isClaimDisabled,
  selectedMenuItem,
  updateArticleLoyality,
}) => {
  if (!selectedMenuItem.rewardTotalPtRequired) {
    return null;
  }

  return (
    <button
      onClick={() =>
        updateArticleLoyality && updateArticleLoyality(!articleClaimed)
      }
      className={`rewardClaimBtn ${isClaimDisabled ? "disabled" : ""}`}
      disabled={isClaimDisabled}
    >
      <p style={{ margin: 0,color:"#000" }}>{articleClaimed ? "Annuler" : "Profitez"}</p>
      <span style={{ fontSize: "14px", fontWeight: "bold" }}>
        {articleClaimed ? (
          <CancelOutlined fontSize="small" />
        ) : (
          <Add fontSize="small" />
        )}
      </span>
    </button>
  );
};

export default RewardClaimButton;
